import { createStore } from '@stencil/store';
import { TermsAndConditionsState } from 'types';
import { triggerTrackEvent } from 'utils/events';

const { state, onChange, on, set, reset } = createStore<TermsAndConditionsState>({
  accepted: true,
});

onChange('accepted', newValue => {
  if (newValue) {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('acceptTermsAndConditions', 'true');
    }

    window.document.dispatchEvent(new CustomEvent('chat-assistance-accepted-terms-and-conditions'));

    triggerTrackEvent({
      event_type: 'user',
      event_name: 'terms_and_conditions_accept',
    });
  } else {
    triggerTrackEvent({
      event_type: 'user',
      event_name: 'terms_and_conditions_show',
    });
  }
});

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
